module.exports = __webpack_public_path__ + "img/weChat.3047a360.jpg";